import { z } from 'zod';
import { FlowBlockType, FlowObsoleteBlockType } from './type.js';
export const FlowAnyBlockTypeSchema = z.enum(FlowBlockType).or(z.enum(FlowObsoleteBlockType));
//# sourceMappingURL=anyBlockType.js.map